import { render, staticRenderFns } from "./StatisticalData.vue?vue&type=template&id=089e41f0&"
import script from "./StatisticalData.vue?vue&type=script&lang=js&"
export * from "./StatisticalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports